import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Inputs } from '@bellawatt/use-inputs';
import getDefaultsWithApi from './use-inputs/getDefaults';
import computed from './use-inputs/computed';
import App from './App/App';
import { APIProvider } from '@vis.gl/react-google-maps';
import ReactIntlProvider from './utils/ReactIntlProvider';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from '../src/config/theme.js';
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import IncentivesContext from './utils/IncentivesContext';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cache = createCache({
  key: 'css',
  nonce: 'm7yvr64n3ob2ci9xdpl',
});

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line import/no-extraneous-dependencies, global-require
  const axe = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

ChartJS.register(...registerables, ChartDataLabels);

ReactDOM.render(
  <BrowserRouter>
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['places']}>
          <Inputs
            computed={computed}
            defaults={getDefaultsWithApi()}
            ignore={['apiElectricVehicles', 'apiFossilVehicles', 'apiChargers', 'apiIncentives']}
          >
            <IncentivesContext>
              <ReactIntlProvider>
                <App />
              </ReactIntlProvider>
            </IncentivesContext>
          </Inputs>
        </APIProvider>
      </ThemeProvider>
    </CacheProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);
